import {instanceAxios} from './instanceAxios'

const getLoginRequest = data => {
  const {userName, password} = data;
  const requestDto = {
    userName: userName,
    password: password,
    applicationId: 1
  }
  return instanceAxios.post('/accounts/login', requestDto)
}

export {getLoginRequest}
